import type { NavEntry } from '../store/app'

// The chat this device is showing, for push suppression: the relay skips a chat
// push to a device that's already looking at it. Derived from the top of the
// nav stack alone — one source of truth, so there's no ordering race between a
// thread screen and its room closing at once, and a room buried under another
// screen (agent settings opened on top) no longer counts as open.
//
// A thread on top shows that thread; on a wide window its room is beside it,
// and on a phone the room sits right under it. Either way the relay treats the
// room as open too, as it always has with a thread open.
export type ActiveChat = { roomID: string; threadRootID?: string }

export function activeChatFor(top: NavEntry | undefined): ActiveChat | null {
  if (!top) return null
  if (top.kind === 'chat_thread') return { roomID: top.roomID, threadRootID: top.rootID }
  if (top.kind === 'chat_room') return { roomID: top.roomID }
  return null
}
